<template>
  <div class="w-56">
    <div class="mb-4 grid grid-cols-5 gap-2">
      <template v-for="key in pinInputKeys" :key="key">
        <div :class="$style.squareHack">
          <button
            type="button"
            class="absolute inset-0 flex size-full items-center justify-center rounded-lg border-2 bg-background shadow"
            :class="
              currentInputKey === key
                ? 'border-primary'
                : inputMap[key]
                  ? 'border-primary/20'
                  : 'border-background-fg/20'
            "
          >
            <template v-if="inputMap[key] !== undefined">
              <template v-if="isPinVisible">
                {{ inputMap[key] }}
              </template>
              <template v-else>
                <IconDot />
              </template>
            </template>
          </button>
        </div>
      </template>
      <div :class="$style.squareHack">
        <button
          type="button"
          class="absolute inset-0 flex size-full items-center justify-center"
          @pointerdown.prevent="togglePinVisible"
          @contextmenu.prevent
        >
          <template v-if="isPinVisible">
            <IconEye />
          </template>
          <template v-else>
            <IconEyeOff />
          </template>
        </button>
      </div>
    </div>
    <div class="mb-2 grid grid-cols-3 gap-2">
      <template v-for="number in numbers" :key="number">
        <div :class="$style.squareHack">
          <button
            type="button"
            class="absolute inset-0 flex w-full items-center justify-center rounded-lg border border-background-fg/20 bg-background p-3 text-lg shadow"
            @pointerdown.prevent="handleNumberPress(number)"
            @contextmenu.prevent
          >
            {{ number }}
          </button>
        </div>
      </template>
      <div :class="$style.squareHack">
        <button
          type="button"
          class="absolute inset-0 flex w-full items-center justify-center rounded-lg border border-background-fg/20 bg-background p-3 text-lg shadow"
          @pointerdown.prevent="handleBackspace"
          @contextmenu.prevent
        >
          <IconBackspace />
        </button>
      </div>
      <div :class="$style.squareHack">
        <button
          type="button"
          class="absolute inset-0 flex w-full items-center justify-center rounded-lg border border-background-fg/20 bg-background p-3 text-lg shadow"
          @pointerdown.prevent="handleNumberPress(0)"
          @contextmenu.prevent
        >
          0
        </button>
      </div>

      <div :class="$style.squareHack">
        <button
          type="button"
          class="absolute inset-0 flex w-full items-center justify-center rounded-lg border border-background-fg/20 bg-background p-3 text-lg shadow"
        >
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    modelValue?: string | null
    name?: string
    standalone?: boolean
  }>(),
  { modelValue: "", name: "", standalone: false }
)
const emit = defineEmits<{
  (eventName: "update:modelValue", value: string): void
}>()

const numbers = [7, 8, 9, 4, 5, 6, 1, 2, 3]

const currentInputKey = computed(
  () => inputMap.value.length
)

const pinInputKeys = [0, 1, 2, 3]
const inputMap = computed<(number | undefined)[]>({
  get: () =>
    [...(props.modelValue || "")]
      .map((value) => Number(value))
      .slice(0, 4),
  set: (value) => {
    emit("update:modelValue", value.slice(0, 4).join(""))
  },
})

const handleNumberPress = (number: number) => {
  if (currentInputKey.value !== 4) {
    inputMap.value = [...inputMap.value, number]
  }
}

const handleBackspace = () => {
  inputMap.value = inputMap.value.slice(0, -1)
}

const isPinVisible = ref(false)
const togglePinVisible = () => {
  isPinVisible.value = !isPinVisible.value
}
</script>

<style lang="scss" module>
.squareHack {
  position: relative;
  padding-top: 100%;
}
</style>
